if (!customElements.get('nosto-product-card')) {
  class NostoProductCard extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
    }

    get productHandle() {
      return this.dataset.handle;
    }

    connectedCallback() {
      if (!this.productHandle) {
        this.renderError('Missing product handle');
        return;
      }

      if (this.loaded) return;

      this.renderLoading();

      // Lazy load when element is visible
      this.observer = new IntersectionObserver(
        ([entry], observer) => {
          if (entry.isIntersecting) {
            this.fetchProduct();
            observer.unobserve(entry.target);
          }
        },
        { rootMargin: '300px' }
      ); // preload just before it appears

      this.observer.observe(this);

      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(e) {
      const link = e.target.closest('[data-product-anchor-link]');
      if (!link) return;
      const productId = link.dataset.productId,
        url = link.href;
      if (!productId || !url) return;
      nostojs((api) => {
        api.recordSearchClick('category', {
          productId,
          url,
        });
      });
    }

    renderLoading() {
      this.innerHTML = `<div class="nosto-card__loading"> </div>`;
    }

    renderError(message) {
      this.innerHTML = `
        <div class="nosto-card__error">
          Error loading product: ${message}
        </div>
      `;
    }

    fetchProduct() {
      const cachedCard = NostoProductCard.productCardCache.get(this.productHandle);
      if (cachedCard) {
        this.innerHTML = cachedCard;
        this.loaded = true;
        return;
      }
      fetch(`/products/${this.productHandle}?view=card`)
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const productCard = doc.querySelector('nosto-product-card');
          if (!productCard) throw new Error('Product card markup not found in response');

          const markup = productCard.innerHTML;
          NostoProductCard.productCardCache.set(this.productHandle, markup);

          this.innerHTML = markup;
          this.loaded = true;
        })
        .catch((err) => {
          console.error(err);
          this.renderError(err.message);
        });
    }
  }

  customElements.define('nosto-product-card', NostoProductCard);
  NostoProductCard.productCardCache = new Map();
}
